import { useLang } from "@/context/LanguageContext";
import { SERVICES, MENUS, SERVICE_IMAGES } from "@/data/villas";
import { Waves, UtensilsCrossed, Car, Flower, Baby, Sparkles, Users } from "lucide-react";
import SEO from "@/components/SEO";

function Block({ icon: Icon, title, rows, image }) {
  return (
    <div className="dh-card overflow-hidden">
      {image && (
        <div className="aspect-[16/9] overflow-hidden">
          <img src={image} alt={title} className="h-full w-full object-cover" />
        </div>
      )}
      <div className="p-8">
        <div className="flex items-center gap-3 mb-6">
          <Icon className="h-5 w-5 text-[color:hsl(var(--dh-terracotta))]" />
          <div className="font-serif text-2xl">{title}</div>
        </div>
        <ul className="divide-y divide-[color:hsl(var(--dh-ocre)/0.15)]">
          {rows.map((r, i) => (
            <li key={i} className="py-3 flex justify-between items-baseline gap-6 text-sm">
              <span className="text-[color:hsl(var(--dh-ink))]">{r.label}</span>
              <span className="font-medium text-[color:hsl(var(--dh-terracotta))] whitespace-nowrap">{r.price}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function Services() {
  const { t } = useLang();
  return (
    <>
      <SEO pageKey="services" />
      <section className="dh-container pt-16 pb-12">
        <div className="dh-overline">{t.services.overline}</div>
        <h1 className="font-serif text-5xl md:text-6xl mt-4">{t.services.title}</h1>
      </section>

      <section className="dh-container pb-24 grid md:grid-cols-2 gap-6">
        <Block icon={Waves} title={t.services.pool} rows={SERVICES.pool} image={SERVICE_IMAGES.pool} />
        <Block icon={UtensilsCrossed} title={t.services.dining} rows={SERVICES.dining} image={SERVICE_IMAGES.chef} />
        <Block icon={Car} title={t.services.transport} rows={SERVICES.transport} />
        <Block icon={Flower} title={t.services.wellness} rows={SERVICES.wellness} image={SERVICE_IMAGES.spa} />
        <Block icon={Baby} title={t.services.nanny} rows={SERVICES.nanny} />
        <Block icon={Sparkles} title={t.services.housekeeping} rows={SERVICES.housekeeping} />
        <div className="md:col-span-2">
          <Block icon={Users} title={t.services.extras} rows={SERVICES.extras} />
        </div>
      </section>

      {/* Menus Din'Art */}
      <section className="bg-[color:hsl(var(--dh-palm))] text-[color:hsl(var(--dh-sand))]">
        <div className="dh-container py-24">
          <div className="max-w-xl mb-12">
            <div className="dh-overline text-[color:hsl(var(--dh-ocre))]">Din&apos;Art · Chef privé</div>
            <h2 className="font-serif text-4xl md:text-5xl mt-4">{t.services.menu}</h2>
            <p className="mt-4 opacity-85">{t.services.menuIntro}</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div className="dh-overline text-[color:hsl(var(--dh-ocre))]">Petit-déjeuner</div>
              <div className="mt-4 space-y-6">
                {Object.entries(MENUS.breakfast).map(([k, items]) => (
                  <div key={k}>
                    <div className="font-serif text-xl capitalize">{k}</div>
                    <ul className="mt-2 text-sm opacity-85 space-y-1">
                      {items.map((x) => <li key={x}>· {x}</li>)}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="dh-overline text-[color:hsl(var(--dh-ocre))]">Entrées</div>
              <ul className="mt-4 text-sm opacity-90 space-y-2">
                {MENUS.entrees.map((x) => <li key={x}>· {x}</li>)}
              </ul>
              <div className="dh-overline text-[color:hsl(var(--dh-ocre))] mt-8">Desserts</div>
              <ul className="mt-4 text-sm opacity-90 space-y-2">
                {MENUS.desserts.map((x) => <li key={x}>· {x}</li>)}
              </ul>
            </div>
            <div>
              <div className="dh-overline text-[color:hsl(var(--dh-ocre))]">Plats</div>
              <ul className="mt-4 text-sm opacity-90 space-y-2">
                {MENUS.plats.map((x) => <li key={x}>· {x}</li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
